import { PasswordResetSetPage } from '@repo/ui';
import { usePasswordResetFlow } from 'presentation/app/contexts/PasswordResetFlowContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSetNewPassword } from '../hooks/useSetNewPassword';
import { getEnv } from 'shared/get-env';

export const PageSetNewPassword = () => {
  // hooks
  const { state: flowState } = usePasswordResetFlow();
  const { loadingChangeNewPassword, validationSetNewPassword } =
    useSetNewPassword();
  const navigate = useNavigate();

  // effect
  useEffect(() => {
    if (!flowState.cpf || !flowState.codeVerified) {
      navigate('/redefinir-senha');
    }
  }, [flowState.cpf, flowState.codeVerified, navigate]);

  if (!flowState.cpf || !flowState.codeVerified) {
    return null;
  }

  return (
    <PasswordResetSetPage
      loading={loadingChangeNewPassword}
      img={getEnv('REACT_APP_URL_LOGO')}
      validation={validationSetNewPassword}
    />
  );
};
